// merge-request-delegated-gates-note.ts — 06k C9 (P5, bất biến 8): mô tả Draft MR
// nói thẳng gate nào do Claude duyệt ủy nhiệm và rằng chưa người nào đọc diff
// trước MR. Quét `gate_approved.source` trong journal; không gate ủy nhiệm ⇒ `[]`
// ⇒ mô tả MR byte như cũ (golden I1). Nối vào khối "Quyết định trong mission"
// ở draft-merge-request-push.ts (caller của khối sổ — đo bước 1(b)).
// Review L4: mô tả MR dựng lúc push Draft MR — TRƯỚC G3 — nên ghi chú không bao giờ
// nêu được G3; G3 ủy nhiệm chỉ thấy ở journal (`gate_approved.source`) và `status`.
import { join } from "node:path";
import { CHAT_DELEGATED_SOURCE } from "./chat-delegated-attribution.js";
import { scanJournal } from "./journal-scan-report.js";
import { MISSION_JOURNAL_FILE_NAME } from "./mission-store.js";

const GATE_ORDER = ["g0", "g1", "g2", "g3"] as const;

export async function mergeRequestDelegatedGatesNote(controlRoot: string): Promise<string[]> {
  const scan = await scanJournal(join(controlRoot, MISSION_JOURNAL_FILE_NAME));
  const delegated = new Set<string>();
  for (const { delta } of scan.records) {
    if (delta.kind !== "gate_approved" || delta.source !== CHAT_DELEGATED_SOURCE) continue;
    if (typeof delta.gate === "string") delegated.add(delta.gate);
  }
  const gates = GATE_ORDER.filter((g) => delegated.has(g)).map((g) => g.toUpperCase());
  if (gates.length === 0) return [];
  return [
    `${gates.join(", ")} do Claude thay chủ mission (qua chat) duyệt — chưa người nào đọc diff trước MR`,
  ];
}
